import { FC, HTMLAttributes } from 'react';
import { useProductContext } from './useProductContext';
import cn from 'classnames';
import { Rate } from '@base/lib/Rate';
import { toRecord } from 'base/utils/data';

export type IProductRateProps = HTMLAttributes<HTMLDivElement>;

export const ProductRate: FC<IProductRateProps> = props => {
    const {
        product: {
            review: {
                num,
                score
            },
        },
        rate
    } = useProductContext();

    if (rate === false) {
        return null;
    }

    const { className } = props;

    const config = toRecord(rate);

    return (
        <Rate
            className={cn('g-rate', className)}
            value={Number(score)}
            total={num}
            type={config.type || 'simple'}
            starSize={config.starSize || false}
        />
    )
};